import { useMemo } from "react";

import { Sex } from "~/graphql";

import { questions } from "./InputQuestionnaire/questions";
import { Fields } from "./types";

export const useDefaultValues = () => {
  const defaultValues: Fields = useMemo(
    () => ({
      date: undefined,
      startTime: "",
      endTime: "",
      prescriptions: [],
      familyName: "",
      givenName: "",
      phoneticFamilyName: "",
      phoneticGivenName: "",
      mobilePhone: "",
      birthDate: "",
      sex: Sex.Male,
      answers: {
        question1: {
          title: questions[0].subject,
          value: [],
        },
        question2: {
          title: questions[1].subject,
          value: [],
        },
        question3: {
          title: questions[2].subject,
          value: [],
        },
        question4: {
          title: questions[3].subject,
          value: [],
        },
        question5: {
          title: questions[4].subject,
          value: [],
        },
      },
      isAgreed: false,
    }),
    [],
  );

  return defaultValues;
};
